import React from 'react';
import './terms.css';
// import Header from '../landingpage/header.js';

const Terms = () => {
  return (
    <div className="terms-container">
      {/* <Header /> */}
      <div className="terms-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: December 19, 2023</p>

        <section className="terms-section">
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing and using InspiraPix, you agree to be bound by these Terms of Service
            and all applicable laws and regulations. If you do not agree with any of these terms,
            you are prohibited from using or accessing this site.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily access the materials (information or software)
            on InspiraPix's website for personal, non-commercial transitory viewing only.
          </p>
          <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by InspiraPix at any time.</p>
          
          <h3>Under this license, you may not:</h3>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to decompile or reverse engineer any software contained on InspiraPix</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. User Accounts</h2>
          <p>
            When you create an account with us, you must provide accurate, complete, and current
            information. Failure to do so constitutes a breach of the Terms, which may result
            in immediate termination of your account.
          </p>
          <p>
            You are responsible for safeguarding the password that you use to access the service
            and for any activities or actions under your password.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. User Content</h2>
          <p>
            Our service allows you to post, link, store, share and otherwise make available
            certain information, text, graphics, or other material ("Content").
          </p>
          <p>
            You retain any and all of your rights to any Content you submit, post or display
            on or through the service and you are responsible for protecting those rights.
          </p>
          <p>You represent and warrant that:</p>
          <ul>
            <li>The Content is yours or you have the right to use it</li>
            <li>The Content does not violate the rights of any third party</li>
            <li>The Content complies with these Terms of Service</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. AI-Generated Content</h2>
          <p>
            When using our AI image generation services, you agree that:
          </p>
          <ul>
            <li>You will not generate content that infringes on copyrights or trademarks</li>
            <li>You will not generate content that is illegal, harmful, or offensive</li>
            <li>You understand that AI-generated content may have limitations and biases</li>
            <li>You accept responsibility for how you use and share AI-generated content</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. Prohibited Uses</h2>
          <p>You may not use our service for any illegal or unauthorized purpose. You agree not to:</p>
          <ul>
            <li>Violate any laws or regulations</li>
            <li>Harass, abuse, or harm another person</li>
            <li>Impersonate another user or person</li>
            <li>Use the service for any harmful or malicious purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>7. Payment Terms</h2>
          <p>
            Paid services are billed in advance on a subscription basis. You agree to pay all
            charges at the prices then in effect for your purchases.
          </p>
          <p>
            You must provide current, complete, and accurate billing information. By submitting
            payment information, you authorize us to charge your payment method for all purchases.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability,
            for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
          <p>
            Upon termination, your right to use the service will immediately cease. If you wish
            to terminate your account, you may simply discontinue using the service.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Limitation of Liability</h2>
          <p>
            In no event shall InspiraPix, nor its directors, employees, partners, agents,
            suppliers, or affiliates, be liable for any indirect, incidental, special,
            consequential or punitive damages.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. We will provide
            notice of any changes by posting the new Terms on this page and updating the
            "Last Updated" date.
          </p>
        </section>

        <section className="terms-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:legal@inspirapix.com">legal@inspirapix.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms; 